// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"XghoBd"};